// @flow
import React from 'react'
import type { Node } from 'react'
import { Dropdown, Icon } from 'semantic-ui-react'

// !FIXME - Easy - Accurately type the options prop. No Object, Any, or Function!!
// !FIXME - Easy - Accurately type the handleChange prop. No Object, Any, or Function!!
const FlyersGridMenuDropdown = ({
  trigger,
  options,
  icon,
  className,
  defaultValue,
  handleChange
}: {
  trigger: Node,
  options: Array<{ text: string, value: string }>,
  icon: ?string,
  className: ?string,
  defaultValue: string,
  handleChange: any
}) => (
  <Dropdown
    inline
    trigger={trigger}
    options={options}
    icon={<Icon as="span" name={icon} />}
    className={`flyer-dropdown ${className || ''}`}
    defaultValue={defaultValue}
    onChange={handleChange}
    style={{ marginRight: '-.25rem' }}
  />
)

FlyersGridMenuDropdown.defaultProps = {
  icon: 'chevron down'
}

export default FlyersGridMenuDropdown



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridMenu/components/FlyerGridMenuDropdown.js